import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Tooltip } from "@/components/Tooltip/Tooltip";
import { classNames } from "@/utils/classNames";

import { CatalogTileRequirement } from "../config/tileCatalog";

const badgeClasses: Record<CatalogTileRequirement, string> = {
	[CatalogTileRequirement.LINKEDIN_ACCOUNT]:
		"bg-blue-action-200 text-blue-action border-action-400",
	[CatalogTileRequirement.SALES_NAVIGATOR]: "bg-blue-100 text-blue-800 border-blue-300",
	[CatalogTileRequirement.COMPANY_ADMIN]:
		"bg-status-error-light text-status-error border-status-error-light",
	[CatalogTileRequirement.WEBSITE_SCRAPE_CREDITS]:
		"bg-status-success-light text-status-success border-green-200",
	[CatalogTileRequirement.TRACKER_AS_LIST_FEATURE]: "bg-tag text-tag-dark border-tag-light",
	[CatalogTileRequirement.SMART_LIST_FEATURE]: "bg-tag text-tag-dark border-tag-light",
};

interface RequirementBadgeProps {
	requirement: CatalogTileRequirement;
}

export const RequirementBadge: FunctionComponent<RequirementBadgeProps> = ({ requirement }) => {
	const { t } = useTranslation();
	const baseKey = `list.create.catalog.requirements.${requirement}`;

	return (
		<Tooltip content={t(`${baseKey}.description`)} direction="top">
			<span
				className={classNames(
					"inline-flex items-center rounded-[10px] border px-2 py-0.5 text-xxs font-semibold",
					badgeClasses[requirement]
				)}
			>
				{t(`${baseKey}.label`)}
			</span>
		</Tooltip>
	);
};
